import actions from './store/actions';
import getters from './store/getters';
import mutations from './store/mutations';
import state from './store/state';

export const name = '$_refferal';
// export const name = "refferal";

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
